<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Products'}">
              <h4 class="ms-2">
                {{label.pages.products}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
              :show-row-lines="true"
              :show-column-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :rtl-enabled="true"
              :data-source="services"
              :columns="serviceFields"
              :remote-operations="true"
              :column-auto-width="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :hover-state-enabled="true"
              :noDataText="checkData"
              @toolbar-preparing="onToolbarPreparing($event)"
              key-expr="id"
              class="ps_Table"
              :height="dataGridHeight"
          >
            <DxSearchPanel
                :visible="true"
                :width="240"
                :placeholder="label.pages.search"
            />
            <DxExport
                :enabled="true"
            />
            <template #btnRGroup>
              <b-row class="btnRLanguage-wrapper" v-show="contentLanguageAccess == 1">
                <b-col cols="3">
                  <label for="language" class="ps_label">
                  {{label.pages.contentLanguage}}
                  </label>
                </b-col>
                <b-col cols="9">
                  <v-select
                      id="language"
                      :options="languages"
                      v-model="selectedLanguage"
                      :reduce="group => group.id"
                      :clearable="false"
                      size="sm"
                      class="ps_select w-100"
                      @input="setLanguage"
                  >
                  </v-select>
                </b-col>
              </b-row>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1">
                    <b-button
                        variant="ps-success"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.router.AddServices"
                        @click="add"
                    >
                      <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-0">
                    <b-button
                        variant="ps-secondary"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.reload"
                        @click="reloadContent"
                    >
                      <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{data}">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #image="{data}">
              <div>
                <img :src="data.data.imageAddress" class="ps_table_inside_img"/>
              </div>
            </template>
            <template #actions="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-0">
                  <button
                      @click="edit(data)"
                      :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-0 pe-2">
                  <button
                      @click="del(data)"
                      :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxLoadPanel :enabled="true"/>
            <DxScrolling mode="virtual"/>
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!-- Delete Service Confirm Modal -->
    <b-modal
        dir="rtl"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center">
            {{ label.captions.deleteConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deleteService"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: "ServicesPage",
  mixins: [dataGridMixin, contentLanguage],
  data() {
    return {
      label,
      serviceFields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'image',
          caption: 'تصویر',
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'title',
          caption: 'عنوان',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'isConfirm',
          caption: 'وضعیت',
          dataType: 'boolean',
          cssClass: 'text-center align-middle'
        },
      ],
      delModal: false,
      delId: null,
      delTitle: '',
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      services: 'baseX/services',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadContent();
      }
    },
  },
  methods: {
    add() {
      this.$router.push({name: 'AddServices'})
    },
    edit(item) {
      this.$router.push({name: 'EditServices', params: {'id': item.data.id}})
    },
    del(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.title;
      this.delModal = true;
    },
    deleteService() {
      this.$store.dispatch('baseX/deleteService', this.delId);
      this.delModal = false;
    },
    reloadContent() {
      this.$store.dispatch('baseX/getServices', this.selectedLanguage);
    },
  },
  mounted() {
    this.reloadContent();
  },
}
</script>
